module.exports = __webpack_public_path__ + "static/media/timer.5f5e03dc.svg";